export const shouldUseLargeStubs = (sourceId: string, targetId: string, navSize: string) => {
  const container = document.getElementById("jsPlumbContainer");
  const sourceElement = document.getElementById(sourceId);
  const targetElement = document.getElementById(targetId);
  if (!sourceElement || !targetElement || !container) {
    return true;
  }
  const sourceRect = sourceElement.getBoundingClientRect();
  const targetRect = targetElement.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();
  const sourceRightEdge = sourceRect.right - containerRect.left;
  const targetLeftEdge = targetRect.left - containerRect.left;
  const horizontalDistance = targetLeftEdge - sourceRightEdge;
  const containerWidth = containerRect.width;

  let sideBarAdjustment;
  switch (navSize) {
    case "large": {
      sideBarAdjustment = 13;
      break;
    }
    case "full": {
      sideBarAdjustment = 30;
      break;
    }
    default: {
      sideBarAdjustment = 0;
      break;
    }
  }
  const relativeDistancePercentage = (horizontalDistance / containerWidth) * 100 + sideBarAdjustment;
  return relativeDistancePercentage >= 15;
};
